import { render, staticRenderFns } from "./SpellMaker.vue?vue&type=template&id=20c51419&"
import script from "./SpellMaker.vue?vue&type=script&lang=js&"
export * from "./SpellMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports